import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import RoundIcon from "connectui/component/display/RoundIcon";
import MessageFile from "./MessageFile";

const useStyles = (theme) =>
  buildStyles({
    bubble: {
      padding: theme.spacing(2.5, 3.5),
      borderRadius: `${theme.radius.lg}px`,
      backgroundColor: theme.colors.white,
      border: `1px solid ${theme.colors.border}`,
      overflowWrap: "anywhere",
      textDecoration: "none !important",
    },
    link: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      wordBreak: "break-word",
      WebkitLineClamp: 2,
    },
  });

const MessageBubbleFile = ({attachment, isGuestSender, openMobileLink}) => {
  const {theme, isMobile} = useTheme();
  const classes = useStyles(theme);

  if (attachment.isImage) {
    return (
      <MessageFile attachment={attachment} onMobileClick={openMobileLink} />
    );
  }

  return (
    <FlexContainer
      as="a"
      href={isMobile ? "#" : attachment.link}
      target="_blank"
      rel="noopener"
      onClick={
        isMobile && attachment.isImage
          ? openMobileLink(attachment.link)
          : undefined
      }
      download={!attachment.isImage}
      justifyContent={isGuestSender ? "flex-start" : "flex-end"}
      gap={theme.spacing(4)}
      className={classes.bubble}
      sx={{
        borderStartStartRadius: `${isGuestSender ? 0 : theme.radius.lg}px`,
        borderStartEndRadius: `${isGuestSender ? theme.radius.lg : 0}px`,
      }}
    >
      <RoundIcon iconComponent="file" baseColor="primary" sx={{margin: 0}} />
      <Text
        variant="textSM"
        weight="medium"
        color="gray700"
        className={classes.link}
      >
        {attachment.link}
      </Text>
    </FlexContainer>
  );
};

export default MessageBubbleFile;
